import React from 'react';
import  ReactMarkdown from 'react-markdown';

export default class Alert extends React.Component {
  render() {
    return (
      <div className="alert alert-info">
        <ReactMarkdown source={this.props.alert} />
      </div>
    );
  }
}
